/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from '@reduxjs/toolkit';

// فقط افترض أن الريودسر مُسجّل باسم `userLogin` في الـ root
export const selectAuthUser = (state: any) => state.userLogin?.AuthUser;

export const getPersonId = createSelector(
  selectAuthUser,
  (AuthUser) => AuthUser?.personId || null
);

export const getBusinessGroupIdForPerson = createSelector(
  selectAuthUser,
  (AuthUser) => AuthUser?.businessGroupId || null
);